





















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppRadioSelection extends Vue {
    @Prop() readonly options!: object[]
    @Prop() readonly selected!: string
    @Prop() readonly buttonName!: string
    @Prop() readonly value: string
    @Prop() readonly displayDirection: string
    @Prop() readonly disabled: boolean

    flexDisplay () {
      if (this.displayDirection) {
        return {
          display: 'flex',
          'flex-direction': this.displayDirection
        }
      }
      return {
        display: 'flex',
        'flex-direction': 'column'
      }
    }

    disabledButton () {
      if (this.disabled) {
        return this.disabled
      }
      return false
    }

    onClick (option) {
      if (option.disableClickAction) {
        return
      }

      if (option.value === this.value) {
        this.$emit('input', null)
        this.$emit('toggle', null)
      } else {
        this.$emit('input', option.value)
        this.$emit('toggle', option.value)
      }
    }
}
